import store from '../../admin/store'

/**
 * Load sports from API
 *
 * @return {AxiosPromise}
 */
export const loadSportsPromise = () => (
    window.axios.get(`${window.APP_CONFIG.REACT_APP_API_URL}api/sports`)
)

/**
 * Load sports and save it into store
 *
 * @return {Promise}
 */
export const loadSportsToStore = () => {
    const { busy } = store.getState().sports

    if (busy) {
        return new Promise(resolve => resolve())
    }

    store.dispatch({
        type: 'SPORTS_SET_BUSY',
        busy: true,
    })

    return loadSportsPromise()
        .then(response => {
            const sports = response?.data

            store.dispatch({
                type: 'SPORTS_SET_DATA',
                data: sports,
            })
        })
        .finally(() => (
            store.dispatch({
                type: 'SPORTS_SET_BUSY',
                busy: false,
            })
        ))
}
